import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideInOutAnimation = trigger('slideInOut', [
  state('out', style({ transform: 'translateX(100%)' })),
  state('in', style({ transform: 'translateX(0)' })),
  transition('out <=> in', animate('0.2s ease-in-out')),
]);
